module.exports = __webpack_public_path__ + "img/rsz_bali-ricefield-1.2ec6cf84.jpg";